module.exports = __webpack_public_path__ + "img/p9-p1-tips2.acd4467a.png";